export default __webpack_public_path__ + "static/media/fallback-image.fb22df08.png";